<template>
    <div class="datagrid-wrapper">

        <user-centre-select-component
            v-on:select:centre="centreSelected"
            v-on:reset="reset"
            v-bind:options="user_centres">
        </user-centre-select-component>

        <br/>

        {{ name_header }}

<!--            office table-->
            <table v-if="this.centre_id" class="datagrid table">
                <thead>
                <tr>
                    <th v-for="header in table_headers">
                        <div v-if="header === 'name' ">
                            <button type="button" class="btn btn-link" @click="sortBy('name')">office &#8597;</button>
                        </div>
                        <div v-else>
                            <span class="btn-link">{{ header }}</span>
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="officeAccessItemsIsLoading">
                    <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
                </tr>
                <tr v-else-if="!access_offices.data?.length">
                    <td :colspan="table_headers.length">No results</td>
                </tr>
                <tr v-else v-for="item in access_offices.data" v-bind:key="item.id">
                    <td v-for="column in table_columns">
                        <div v-if="column === 'inventory_name'">
                            <a :href="`/centre/inventory/${item.id}`">{{ item.inventory_link_text }}</a>
                        </div>
                        <div v-else-if="column === 'time_period'" class="text-nowrap">
                            <span v-if="item.rule_count > 1">
                                Multiple timeframes
                            </span>
                            <span v-else-if="item.access_rule.start_date !== null">
                                 <span>{{ $formatDate(item.access_rule.start_date, user_date_format) }} / </span>
                                 <span v-if="item.access_rule.end_date !== null">
                                     {{ $formatDate(item.access_rule.end_date, user_date_format) }}
                                 </span>
                                 <span v-else>No end date</span>
                            </span>
                            <span v-else>
                                 <span>No start date</span>
                            </span>
                        </div>
                        <div v-else-if="column === 'hours'" class="text-nowrap">
                            <span v-if="item.rule_count > 1">
                                Multiple timeframes
                            </span>
                            <span v-else>{{ item.access_rule.hours }}</span>
                        </div>

                        <div v-else-if="column === 'centre_name'">{{ item[column] }}</div>
                        <div v-else-if="column === 'status'">
                            <span :class="{
                                'text-active': item.access_rule.status === 'active',
                                'text-danger': item.access_rule.status === 'expired',
                                'text-inactive': item.access_rule.status === 'inactive'
                            }">{{ item.access_rule.status }}</span>
                        </div>
                        <div v-else-if="column === 'access_rules'" v-html="item[column]"></div>
                        <div v-else-if="column === 'action' && can_create_edit_access" v-html="item.action"></div>
                    </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <td colspan="7">
                        <pagination :data="access_offices" :limit=3 @pagination-change-page="page => getOfficeAccessItems(centre_id, page)">
                            <template #prev-nav>
                                <span>&lt; Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next &gt;</span>
                            </template>
                        </pagination>
                    </td>
                </tr>
                </tfoot>
            </table>

<!--        space table-->
        <table v-if="this.centre_id" class="datagrid table">
            <thead>
            <tr>
                <th v-for="header in table_headers">
                    <div v-if="header === 'name' ">
                        <button type="button" class="btn btn-link">space</button>
                    </div>
                    <div v-else>
                        <span class="btn-link">{{ header }}</span>
                    </div>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="spaceAccessItemsIsLoading">
                <td :colspan="table_headers.length"><span class="spinner anim-spin"></span></td>
            </tr>
            <tr v-else-if="!access_spaces.data?.length">
                <td :colspan="`${table_headers.length}`">No results</td>
            </tr>
            <tr v-else v-for="item in access_spaces.data" v-bind:key="item.id">
                <td v-for="column in table_columns">
                    <div v-if="column === 'inventory_name'">
                        <a :href="`/centre/inventory/${item.id}`">{{ item.inventory_link_text }}</a>
                    </div>
                    <div v-else-if="column === 'time_period'" class="text-nowrap">
                            <span v-if="item.rule_count > 1">
                                Multiple timeframes
                            </span>
                        <span v-else-if="item.access_rule.start_date !== null">
                                 <span>{{ $formatDate(item.access_rule.start_date, user_date_format) }} / </span>
                                 <span v-if="item.access_rule.end_date !== null">
                                     {{ $formatDate(item.access_rule.end_date, user_date_format) }}
                                 </span>
                                 <span v-else>No end date</span>
                            </span>
                        <span v-else>
                                 <span>No start date</span>
                            </span>
                    </div>
                    <div v-else-if="column === 'hours'" class="text-nowrap">
                            <span v-if="item.rule_count > 1">
                                Multiple timeframes
                            </span>
                        <span v-else>{{ item.access_rule.hours }}</span>
                    </div>

                    <div v-else-if="column === 'centre_name'">{{ item[column] }}</div>
                    <div v-else-if="column === 'status'">
                            <span :class="{
                                'text-active': item.access_rule.status === 'active',
                                'text-danger': item.access_rule.status === 'expired',
                                'text-inactive': item.access_rule.status === 'inactive'
                            }">{{ item.access_rule.status }}</span>
                    </div>
                    <div v-else-if="column === 'access_rules'" v-html="item[column]"></div>
                    <div v-else-if="column === 'action' && can_create_edit_access" v-html="item.action"></div>
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td colspan="7">
                    <pagination :data="access_spaces" @pagination-change-page="page => getSpaceAccessItems(centre_id, page)">
                        <template #prev-nav>
                            <span>&lt; Previous</span>
                        </template>
                        <template #next-nav>
                            <span>Next &gt;</span>
                        </template>
                    </pagination>
                </td>
            </tr>
            </tfoot>
        </table>

        </div>
</template>
<script>

export default {
    name: "AccessDataTable",
    props: {
        user_centres: {},
        name_header: {
            type: String,
        },
        api_endpoint: {
            type: String,
        },
        user_date_format: {
            type: String,
        },
        can_create_edit_access: {
            type: Boolean,
        },
        table_headers: {
            type: Array,
        },
        table_columns: {
            type: Array,
        },
    },
    data() {
        return {
            centre_id: '',
            access_offices: {},
            access_spaces: {},
            paginate: 10,
            sort_key: 'name',
            access_type: '',
            reverse: false,
            officeAccessItemsIsLoading: false,
            spaceAccessItemsIsLoading: false,
        }
    },
    watch: {
        paginate: function () {
            this.getOfficeAccessItems(this.centre_id);
            this.getSpaceAccessItems(this.centre_id);
        }
    },
    methods: {
        centreSelected: function (centre) {
            this.centre_id = centre.id
            this.getOfficeAccessItems(centre.id);
            this.getSpaceAccessItems(centre.id);
        },
        reset: function () {
            this.access_offices = {};
            this.access_spaces = {};
        },
        sortBy(sort_key) {
            this.reverse = (this.sort_key === sort_key) ? !this.reverse : false;
            this.sort_key = sort_key;
            this.getOfficeAccessItems(this.centre_id);
        },
        getOfficeAccessItems(centre_id, page = 1) {
            this.officeAccessItemsIsLoading = true;
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    centre_id,
                    access_type: 'offices',
                    paginate: this.paginate,
                    sort_key: this.sort_key,
                    sort_direction: this.reverse ? 'DESC' : 'ASC',
                }
            })
                .then(response => {
                    this.access_offices = response.data;
                    this.officeAccessItemsIsLoading = false;
                });
        },
        getSpaceAccessItems(centre_id, page = 1) {
            this.spaceAccessItemsIsLoading = true;
            axios.get(this.api_endpoint, {
                params: {
                    page,
                    centre_id,
                    access_type: 'spaces',
                    paginate: this.paginate,
                }
            })
                .then(response => {
                    this.access_spaces = response.data;
                    this.spaceAccessItemsIsLoading = false;
                });
        }
    }
}
</script>
<style scoped>
.btn-link, .btn-link:hover {
    letter-spacing: normal;
    padding: 0 30px 0 0;
    margin: 0;
    vertical-align: bottom;
    color: #babfbf;
    font-weight: bold;
    font-size: 11px;
    outline: none !important;
    border: 0;
    text-decoration: none;
    white-space: nowrap;
}
</style>
